import { render, staticRenderFns } from "./wtVoiceOverDropdown.vue?vue&type=template&id=cba83816&scoped=true&"
import script from "./wtVoiceOverDropdown.vue?vue&type=script&lang=js&"
export * from "./wtVoiceOverDropdown.vue?vue&type=script&lang=js&"
import style0 from "./wtVoiceOverDropdown.vue?vue&type=style&index=0&id=cba83816&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cba83816",
  null
  
)

export default component.exports